import React from 'react'
import { DataTool, type DataToolProps } from '@ztechapps/webui.data-tools'
import { useOrderListContext } from './Context'
import { orderListFieldConfig } from './constants'

export const OrderListDataTool = ({ searchPlaceHolder, ...props }: DataToolProps) => {
  const { orderList, onRefresh } = useOrderListContext()

  return (
    <DataTool
      fieldsConfig={orderListFieldConfig}
      onRefresh={onRefresh}
      searchPlaceHolder={searchPlaceHolder ?? 'Search orders'}
      {...orderList}
      {...props}
      onSort={null}
    />
  )
}
